import { SamLineSourceModalData } from '@components/modals/samLineSourceModal/SamLineSourceModal';
import { EventActions, EventCategories } from '@models/analytics/Analytics';
import useTrackEvent from '@hooks/useTrackEvent';

const useSamLineSourceModalEventHandlers = () => {
    const { trackEvent, getCustomDimensions } = useTrackEvent();

    return {
        onOpen: (modalData: SamLineSourceModalData) => {
            const { administrationCode, creditor } = getCustomDimensions(modalData.documentId);

            trackEvent({
                category: EventCategories.SamCodingLines,
                action: EventActions.ModalOpened,
                name: 'LineSourceModal',
                customDimensions: [administrationCode, creditor],
            });
        },
        onClose: (modalData: SamLineSourceModalData) => {
            const { administrationCode, creditor } = getCustomDimensions(modalData.documentId);

            trackEvent({
                category: EventCategories.SamCodingLines,
                action: EventActions.ModalClosed,
                name: 'LineSourceModal',
                customDimensions: [administrationCode, creditor],
            });
        },
    };
};

export default useSamLineSourceModalEventHandlers;
